import api from "@/config/api"; 
import LoggerService from "@/services/LoggerService"; 

export default async function fetchWithCache(
  { commit },
  {
    apicmd,
    cacheKey,
    postData,
    mutation,
    cacheDuration = 60000,
    url,
    method = "POST",
    retryCount = 1,
  }
) {
  const now = Date.now();

  const cachedData = JSON.parse(localStorage.getItem(cacheKey));
  if (cachedData && now - cachedData.timestamp < cacheDuration) {
    console.log(`Using cached data for cmd: ${apicmd}`);
    // Commit mutation even for cached data to ensure state is updated
    if (mutation && typeof commit === "function") {
      commit(mutation, cachedData.data);
    }
    return cachedData.data;
  }

  const fetchData = async (attempt = 1) => {
    try {
      console.log(`Calling API for cmd: ${apicmd}, Attempt: ${attempt}`);

      let response;
      if (method === "POST") {
        response = await api.post(url, postData);
      } else if (method === "GET") {
        response = await api.get(url, { params: postData });
      } else {
        throw new Error(`Unsupported HTTP method: ${method}`);
      }

      const outputData = response.data.output || response.data;

      if (mutation && typeof commit === "function") {
        commit(mutation, outputData);
      }

      const cacheObject = {
        data: outputData,
        timestamp: now,
      };
      localStorage.setItem(cacheKey, JSON.stringify(cacheObject));

      return outputData;
    } catch (error) {
      LoggerService.logError(
        `Error fetching data for cmd: ${apicmd} (attempt ${attempt}). ${error.message}`,
        "fetchWithCache"
      );

      if (error.response?.status === 504 && attempt < retryCount) {
        console.warn(`Retrying API call for cmd: ${apicmd}, Attempt: ${attempt + 1}`);
        return fetchData(attempt + 1);
      } else {
        console.error(`Failed after ${attempt} attempt(s) for cmd: ${apicmd}`, error);
        throw error;
      }
    }
  };

  return fetchData();
}